import axios from "axios";
import Cookies from "js-cookie";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
  token: Cookies.get("ecs_admin_jwt_token"),
  account: []
};

// getters
export const getters = {
  token: state => state.token,
  account: state => state.account
};

// mutations
export const mutations = {
  [types.AUTH.AUTH_LOGIN](state, account) {
    state.token = account.data.token;
    Cookies.set("ecs_admin_jwt_token", account.data.token, {
      expires: account.data.expires_in / 86400
    });
  },

  [types.AUTH.AUTH_LOGOUT](state, account) {
    if (account.status === 200) {
      Cookies.remove("ecs_admin_jwt_token");
      state.token = "";
      state.account = [];
    }
  },

  [types.AUTH.AUTH_REFRESH_TOKEN](state, account) {
    state.token = account.data.token;
    Cookies.set("ecs_admin_jwt_token", account.data.token, {
      expires: account.data.expires_in / 86400
    });
  },

  [types.AUTH.FETCH_AUTH](state, account) {
    state.account = account;
  }
};

// actions
export const actions = {
  login({ commit }, accounts) {
    return new Promise((resolve, reject) => {
      axios
        .post(api.LOGIN, accounts)
        .then(response => {
          commit(types.AUTH.AUTH_LOGIN, response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  logout({ commit }) {
    commit(types.AUTH.AUTH_LOGOUT, { status: 200 });
  },

  refreshToken({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .post(api.REFRESH_TOKEN)
        .then(response => {
          resolve(response);
          commit(types.AUTH.AUTH_REFRESH_TOKEN, response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  accountInfo({ commit }) {
    if (state.account.length === 0) {
      return new Promise((resolve, reject) => {
        axios
          .get(api.ACCOUNT)
          .then(response => {
            resolve(response);
            commit(types.AUTH.FETCH_AUTH, response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  // eslint-disable-next-line
  changePassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(api.CHANGE_PASSWORD, {
          password: payload.password,
          password_new: payload.passwordNew
        })
        .then(response => {
          resolve(response);
          Cookies.remove("ecs_user_jwt_token");
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
